import { PhoneUtils } from '@shared/lib/phone';

import { Country } from '@shared/api/graphql/generated';

export const isBelarusCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.By;
};

export const isKazahstanCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.Kz;
};

export const isRussiaCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.Ru;
};
